import { Injectable } from '@angular/core';
import { StatutDossier } from '../model/statut-dossier';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class StatutDossierService{
  

    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllStatutDossier() 
    {
      return this._restClientService.load<StatutDossier[]>('statut-dossier/statut-dossiers');
    }

    getStatutDossiersByStatusCode(statuscode){
        return this._restClientService.load<StatutDossier>('statut-dossier/statut-dossier-by-statuscode?statuscode='+statuscode);
    }
        

}      

    